// extracted by mini-css-extract-plugin
export default {"control":"styles_control__edWAo","container":"styles_container__iIE0l","icon":"styles_icon__FCnpL","warning":"styles_warning__Qp9uA"};